import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { assets } from '../data/catalog';
import './Navbar.css';

const { FiSearch, FiHeart, FiShoppingBag, FiPackage, FiMenu, FiX } = FiIcons;
const WISHLIST_KEY = 'darshana-wishlist';

function getWishlistCount() {
  try {
    return JSON.parse(window.localStorage.getItem(WISHLIST_KEY) || '[]').length;
  } catch {
    return 0;
  }
}

function Navbar({ cartCount }) {
  const [open, setOpen] = useState(false);
  const [wishlistCount, setWishlistCount] = useState(getWishlistCount);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => setOpen(false), [location.pathname]);

  useEffect(() => {
    const syncWishlist = () => setWishlistCount(getWishlistCount());
    window.addEventListener('darshana-wishlist-updated', syncWishlist);
    window.addEventListener('storage', syncWishlist);

    return () => {
      window.removeEventListener('darshana-wishlist-updated', syncWishlist);
      window.removeEventListener('storage', syncWishlist);
    };
  }, []);

  const scrollToSection = (sectionId) => (event) => {
    event.preventDefault();
    setOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    } else {
      const element = document.getElementById(sectionId);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navLinks = [
    { label: 'Home', to: '/', type: 'route' },
    { label: 'Shop', to: '/shop', type: 'route' },
    { label: 'About Us', to: '/about', type: 'route' },
    { label: 'Contact', to: '/contact', type: 'route' },
    { label: 'Track Order', to: '/track', type: 'route' }
  ];

  return (
    <header className="navbar">
      <Link to="/" className="brand" aria-label="Darshana home">
        <img src={assets.logo} alt="Darshana Global Enterprises" />
      </Link>
      <nav className={`nav-links ${open ? 'nav-open' : ''}`}>
        {navLinks.map((item) =>
          item.type === 'route' ? (
            <Link key={item.label} to={item.to} onClick={() => setOpen(false)}>{item.label}</Link>
          ) : (
            <a key={item.label} href={`#${item.sectionId}`} onClick={scrollToSection(item.sectionId)}>{item.label}</a>
          )
        )}
      </nav>
      <div className="nav-actions">
        <button onClick={() => navigate('/shop?focus=search')} aria-label="Search products">
          <SafeIcon icon={FiSearch} />
        </button>
        <Link to="/checkout" className="cart-action" aria-label="Cart">
          <SafeIcon icon={FiShoppingBag} />
          {cartCount > 0 && <span>{cartCount}</span>}
        </Link>
        <Link to="/track" className="nav-track-btn" aria-label="Track Order">
          <SafeIcon icon={FiPackage} />
        </Link>
        <button className="menu-action" onClick={() => setOpen(!open)} aria-label="Menu">
          <SafeIcon icon={open ? FiX : FiMenu} />
        </button>
      </div>
    </header>
  );
}

export default Navbar;